import { render, staticRenderFns } from "./doctFlowIndex.vue?vue&type=template&id=33b6ac78"
import script from "./doctFlowIndex.vue?vue&type=script&lang=js"
export * from "./doctFlowIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports